import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../modules/shared/shared.global-service';
import { WorkContinuousRecordComponent } from '../work-continuous-record.component';
import {
    FolderContinuousRecordComponent,
} from '../../../folder/folder-continuous-record/folder-continuous-record/folder-continuous-record.component';

@Component({
    selector: 'app-work-continuous-record-dialog',
    templateUrl: './work-continuous-record-dialog.component.html',
    styleUrl: './work-continuous-record-dialog.component.scss',
    imports: [
        WorkContinuousRecordComponent,
        FolderContinuousRecordComponent,
    ],
    providers: [FolderGlobalStore],
})
export class WorkContinuousRecordDialogComponent extends BaseDialogComponent {

    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }

}
